// $(".spr-summary-actions-newreview").addClass(".button-reveal").html("<div class='button-bg' ></div><div class='button-inner' >" +  $(".spr-summary-actions-newreview").html() + "</div>" );

let dataScrollContainer = document.querySelector('[data-scroll-container]');

function scProxy() {
  const searchParams = new URLSearchParams(location.search);
  searchParams.delete('slv_rt');
  const searchParamsStr = searchParams.toString();
  const search = searchParamsStr.length ? '?' + searchParamsStr : '';

  locoScroll.on("scroll", e => {
    ScrollTrigger.update();

    // Save the scroll position on collection pages. To be used to restore it on getting back from the product pages.
    if (location.pathname.match(/\/collections\//i) && !location.pathname.match(/\/products\//i)) {
      localStorage.setItem('scroll', JSON.stringify({
        url: location.pathname + search,
        x: e.scroll.x,
        y: e.scroll.y
      }));
    }
  });

  ScrollTrigger.scrollerProxy(".smooth-scroll", {
    scrollTop(value) {
      return arguments.length ? locoScroll.scrollTo(value, 0, 0) : locoScroll.scroll.instance.scroll.y;
    },
    scrollLeft(value) {
      return arguments.length ? locoScroll.scrollTo(value, 0, 0) : locoScroll.scroll.instance.scroll.x;
    }, 
    getBoundingClientRect() {
      return {top: 0, left: 0, width: window.innerWidth, height: window.innerHeight};
    },
     
    // LocomotiveScroll handles things completely differently on mobile devices - it doesn't even transform the container at all! So to get the correct behavior and avoid jitters, we should pin things with position: fixed on mobile. We sense it by checking to see if there's a transform applied to the container (the LocomotiveScroll-controlled element).
    pinType: document.querySelector(".smooth-scroll").style.transform ? "transform" : "fixed"
  });

  // Save the scroll position on collection pages.
  // To be used on mobile devices to restore it where locomotive does not apply.
  if (location.pathname.match(/\/collections\//i) && !location.pathname.match(/\/products\//i)) {
    window.addEventListener('scroll', () => {
      localStorage.setItem('scroll_native', JSON.stringify({
        url: location.pathname + search,
        x: parseInt(window.scrollX.toString()),
        y: parseInt(window.scrollY.toString())
      }));
    });
  }
}

var reavealEls = document.querySelectorAll(".line-1,.line-2,.is-reveal,.img-reveal");
var horizontal = false;

if( $('[data-scroll-container-hor]').length == 0 ) {
  let initPosition = {x: 0, y: 0};

  const searchParams = new URLSearchParams(location.search);
  searchParams.delete('slv_rt');
  const searchParamsStr = searchParams.toString();
  const search = searchParamsStr.length ? '?' + searchParamsStr : '';

  // Restore the scroll position on collection pages on tablets and desktops (where Locomotive Scroll is in use).
  const lsScroll = JSON.parse(localStorage.getItem('scroll'));
  if (lsScroll && lsScroll.url === location.pathname + search) {
    initPosition = {x: lsScroll.x, y: lsScroll.y};
  }

  // Restore the scroll position on collection pages on mobile devices (Locomotive Scroll is disabled).
  const lsScrollNative = JSON.parse(localStorage.getItem('scroll_native'));
  if (lsScrollNative && lsScrollNative.url === location.pathname + search) {
    const html = document.querySelector('html');
    html.style.scrollBehavior = 'auto';
    window.addEventListener('DOMContentLoaded', () => {
      window.scrollTo(lsScrollNative.x, lsScrollNative.y);
      html.style.scrollBehavior = 'smooth';
    })
  }

  if( document.querySelector('.disable-smooth-scroll') ) {
    window.locoScroll = { update: () => {}, stop: () => {} };
  } else {
    // For vertical scrolling pages
    window.locoScroll = new LocomotiveScroll({
      el: dataScrollContainer,
      smooth: true,
      multiplier: 1.5,
      initPosition,
      touchMultiplier: 3,
      class: 'is-inview',
      repeat: true,
      
      tablet: {
        smooth: true,
      },
      
      smartphone: {
        smooth: false,
      },
    });
  }


} else {
  // Horizontal scrolling pages

  horizontal = true;
  
    $(".progress-bar-header").addClass('active');
    window.locoScroll = new LocomotiveScroll({
      el: dataScrollContainer,
      smooth: true,
      direction: "horizontal",
      multiplier: 1.5,
      class: 'is-inview',
      
      tablet: {
        smooth: true,
        gestureDirection: 'horizontal',
        direction: 'horizontal',
        breakpoint: 768,
      },
      
      smartphone: {
        smooth: false,
      },
    });
  
  

  locoScroll.on('scroll', function(args) {
    const total = args.limit.x;
    const scrolled = args.scroll.x;
    const progress = scrolled/total * 100;
  
    gsap.to("#myBar", {
      width: progress + '%'
    }) 
  })
}

scProxy();

reavealEls.forEach(function(el) {

  // gsap.set(el, {clipPath: 'inset(100% 0% 0% 0%)'});
  gsap.timeline({
    scrollTrigger: {
      trigger: el,
      scroller: ".smooth-scroll",
      start: "top bottom",
      horizontal: horizontal,
      // toggleActions:'restart none none reverse',
    }
  }).fromTo(el, {
    clipPath: 'inset(100% 0% 0% 0%)'
  }, {
    clipPath: 'inset(0% 0% 0% 0%)',
    duration: 1,
  }); 
});


document.querySelectorAll('.button-reveal').forEach(function(el) {

  var borderRadius = el.hasAttribute('data-border-radius') ? el.getAttribute('data-border-radius') : 50;
  var delay = el.hasAttribute('data-delay') ? el.getAttribute('data-delay') : 0;

  var revealTl = gsap.timeline({
    scrollTrigger: {
      trigger: el,
      scroller: ".smooth-scroll",
      start: "top 85%",
      horizontal: horizontal,
      // toggleActions:'restart none none reverse',
    }
  });

  // revealTl.set(el.querySelector(".button-inner"), { width: el.querySelector(".button-inner").offsetWidth });

  revealTl.fromTo(el.querySelector(".button-bg"), {
    scale: .5,
  }, {
    scale: 1,
    duration: .4,
    ease: 'power2.in'
  }, delay + 0);

  revealTl.fromTo(el.querySelector(".button-bg"), {
    width: el.offsetHeight,
    borderRadius: 50,
  }, {
    width: "100%",
    borderRadius: borderRadius,
    duration: .7,
    ease: 'power2.out'
  }, delay + 0.4);

  revealTl.to(el.querySelector(".button-inner"), {
    autoAlpha: 1,
    ease: 'power2.in',
    duration: .7,
  }, delay + 0.4);


})



document.querySelectorAll('.clip-reveal').forEach(function(el) {

  var duration = el.hasAttribute('data-duration') ? el.getAttribute('data-duration') : .8;
  var triggerOffset = el.hasAttribute('data-delay') ? 100 - parseInt(el.getAttribute('data-delay')) : 85;

  var revealTl = gsap.timeline({
    scrollTrigger: {
      trigger: el,
      scroller: ".smooth-scroll",
      start: "top " + triggerOffset + "%",
      horizontal: horizontal,
      // toggleActions:'restart none none reverse',
    }
  });

  revealTl
  .fromTo(el, {
    autoAlpha: 0,
    clipPath: 'inset(100% 0% 0% 0%)'
  }, {
    autoAlpha: 1,
    clipPath: 'inset(0% 0% 0% 0%)',
    duration: duration,
  }, 0)
  .fromTo(el.querySelector(".clip-inner"), {
    y: '20%',
  }, {
    y: '0%',
    duration: duration,
  }, 0);
})




window.addEventListener('load', function() {
  locoScroll.update();
})

/* added for accordian bug-  in progress */
// const detailsElem = document.querySelector(".accordian-title");

// detailsElem.addEventListener(
//   "toggle",
//   function (evt) {
//     if (detailsElem.open) {
//       scroller.update();
//     } else {
//       scroller.update();
//     }
//   },
//   false
// );


$(".loco-scroller").on('click', function(e) {
  e.preventDefault();

  locoScroll.scrollTo($(this).attr('href'), { offset: -100 });
});





// document.addEventListener('DOMContentLoaded', function() {

//   var anchors = document.getElementsByTagName('a');

//   for (var idx=0; idx<anchors.length; idx+=1) {
//     if (anchors[idx].hostname !== window.location.hostname ||
//       anchors[idx].pathname === window.location.pathname) {
//       continue;
//     }

//     anchors[idx].addEventListener('click', function(e) {
//       e.preventDefault();
//       window.location.href = $(this).attr('href');
//       gsap.to('#preloader', {autoAlpha: 1});
//     });
//   }
// });

$(window).on('load', function() {

  setTimeout(function() {
    locoScroll.update();

    setInterval(function() {
      locoScroll.update()
    }, 10000);
  }, 1000);

  // ScrollTrigger.getAll().forEach(function(st) {
  //   if(st.isActive) {
  //     st.animation.pause().progress(0);
  //   }
  // });


  gsap.to('#preloader', {
    autoAlpha: 0,
    onComplete: function() {
      // ScrollTrigger.getAll().forEach(function(st) {
      //   if(st.isActive) {
      //     st.animation.play();
      //   }
      // });    
    }
  });
})

window.onpageshow = function(event) {
  if (event.persisted) {
      window.location.reload(); 
  }
};



// $('.filter-popup #filter-tabs .active').addClass('gsap-active');
$('#filter-tabs > a').on('click', function(e) {
  e.preventDefault();

  if( window.innerWidth <= 768 && !$(this).hasClass('active')) {

    $('#filter-tabs > a').removeClass('active');
    $(this).addClass('active');
    var group = $($(this).attr('href'));
    
    $(".filter-popup .group").removeClass("active");
    group.addClass("active");

    gsap.fromTo( group.find('.checkmark-container'), {
      autoAlpha: 0,
      y: 20,
    }, {
      autoAlpha: 1,
      y: 0,
      duration: .4,
      stagger: .1
    });
  }
});

// $('a.product-filter').on('click', function() {
//   if( window.innerWidth <= 768 ) {
    
//     var popupTl = gsap.timeline({paused: true});

//     popupTl.fromTo($('.filter-popup'), {
//       autoAlpha: 0,
//       y: 50,
//     }, {
//       autoAlpha: 1,
//       y: 0
//     });

//     if( !$('.filter-popup').hasClass('closed') ) {
//       popupTl.play();
//     } else {
//       popupTl.reverse();
//     }
//   }
// })



var motifTl = gsap.timeline({
  scrollTrigger: {
    trigger: '.home-motif, .bc-lp-hero .motif',
    scroller: ".smooth-scroll",
    start: "top bottom",
    horizontal: horizontal,
  }
});

motifTl
.fromTo('.home-motif, .bc-lp-hero .motif', {
  autoAlpha: 0,
  scale: 0,
  rotate: 180,
}, {
  autoAlpha: 1,
  scale: 1,
  rotate: 0,
  duration: 1.5,
  ease: "power2.out"
});


$(".modal-inner").on("scroll", function() {
  if( $(this).scrollTop() > $(this).find(".modal-img-container").height() ) {
    $(this).addClass("n-scrolled");
  } else {
    $(this).removeClass("n-scrolled");
  }
})






$(function() {
  if( $("#shopify-section-announcement").length ) {
    $('body').addClass('has-announcement');
    
    // var announcementTl = gsap.timeline();
    
    // announcementTl
    // .fromTo("#nav-solid, #nav-transparent", {
    //   y: 0,
    // }, {
    //   y: function() { return $("#shopify-section-announcement").height() }
    // }, 0)
    // .fromTo("#shopify-section-announcement", {
    //   y: '-100%',
    // }, {
    //   y: 0,
    // }, 0)

    gsap.to("#nav-solid, #nav-transparent", { y: $("#shopify-section-announcement").height(), duration: 0, });
    locoScroll.on('scroll', function(args) {
      

      if( args.scroll.y > 100 ) {
        $('body').addClass('announcement-hide');
        
      } else {
        $('body').removeClass('announcement-hide');
        
      }

    })
  }
});




function stickyCols() {
  document.querySelectorAll(".sticky-cols").forEach(function(el) {
    var targetId = el.getAttribute('id');
    var stickyCompare = $(el.querySelector(".sticky-compare"));
    var stickyEl = $(el.querySelector(".sticky-div"));
    
    if( stickyCompare.height() > stickyEl.height() ) {
      stickyEl.attr("data-scroll", "");
      stickyEl.attr("data-scroll-sticky", "");
      stickyEl.attr("data-scroll-target", "#" + targetId);
      el.classList.add("will-stick");
    } else {
      stickyEl.removeAttr("data-scroll");
      stickyEl.removeAttr("data-scroll-sticky");
      stickyEl.removeAttr("data-scroll-target");
      el.classList.remove("will-stick");
    }

  })

  locoScroll.update();
}

$(stickyCols);
$(window).on('load', stickyCols);
$(window).on('resize', stickyCols);




function uiFallback() {
  if( window.innerWidth == screen.availWidth ) {
    $("body").addClass("no-uifallback");
  } else {
    $("body").removeClass("no-uifallback");
  }
}

uiFallback();
$(window).on("load", uiFallback);
$(window).on("resize", uiFallback);

if (location.hash === '#contact_form') {
  const el = document.getElementById(location.hash.substring(1));
  if (el) {
    locoScroll.scrollTo(el.getBoundingClientRect().top - 100, 0);
  }
}

if (location.href.match(/\?contact_posted=true$/)) {
  const el = document.getElementById('contact_form');
  if (el) {
    locoScroll.scrollTo(el.getBoundingClientRect().top - 100, 0);
  }
}
